import React from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { notify } from 'components/Common/Toast';
import { Box } from '@mui/material';

interface GeneratePDFProps {
    elementId: string;
    children: React.ReactElement | React.ReactNode;
}

const GeneratePDF = ({ elementId, children }: GeneratePDFProps) => {
    const generatePDF = () => {
        const input = document.getElementById(elementId);
        if (input) {
            html2canvas(input)
                .then((canvas) => {
                    const imgData = canvas.toDataURL('image/png');
                    const pdf = new jsPDF({
                        orientation: 'portrait',
                        unit: 'mm',
                        format: 'a4',
                    });
                    const imgProps = pdf.getImageProperties(imgData);
                    const pdfWidth = pdf.internal.pageSize.getWidth();
                    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
                    pdf.save(`${elementId}.pdf`);
                })
                .catch((error) => {
                    console.error('Error generating PDF:', error);
                    notify('something went wrong', 'error');
                });
        } else {
            console.error(`Element with id "${elementId}" not found.`);
        }
    };

    return <Box onClick={generatePDF}>{children}</Box>;
};

export default GeneratePDF;
